import { type FC } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useIsFeatureAdvertisementEnabled } from '../../common/useIsFeatureAdvertisementEnabled'
import { useZocksQuota } from '../ScopedBlock/hooks'

interface FeatureAdvertisementRouteProps {
  bypassQuotas?: string[]
  redirectTo?: string
}

export const FeatureAdvertisementRoute: FC<FeatureAdvertisementRouteProps> = ({ bypassQuotas = [], redirectTo = '/' }) => {
  const { hasQuota, isFetching: quotasFetching, quotaSuccess } = useZocksQuota()
  const bypass = bypassQuotas.some((quota) => hasQuota(quota))
  const { isEnabled, isLoading: isAccountLoading } = useIsFeatureAdvertisementEnabled({ bypass })

  if ((!quotaSuccess && quotasFetching) || isAccountLoading) {
    return null
  }

  if (!isEnabled) {
    return <Navigate to={redirectTo} replace />
  }

  return <Outlet />
}
